import { render, staticRenderFns } from "./HomeIndicators.vue?vue&type=template&id=ddd78950&scoped=true"
import script from "./HomeIndicators.vue?vue&type=script&lang=js"
export * from "./HomeIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd78950",
  null
  
)

export default component.exports